<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1200240" style="color: #82a339"><b>POKER CHIPS</b></p>
<p class="ext" id="d7e1200740"><b><i>Save on cleanup by lining the cookie sheets with heavy-duty foil or parchment paper.</i></b></p>
<p class="h4" id="d7e1201840" style="color: #496210"><b>Prep: 10 minutes plus cooling     Bake: 8 minutes</b></p>
<p class="ul" id="d7e1202340">½ cup olive oil</p>
<p class="ul" id="d7e1203240">1 tablespoon freshly grated Parmesan <br/> or Pecorino-Romano cheese</p>
<p class="ul" id="d7e1203840">1 tablespoon chili powder</p>
<p class="ul" id="d7e1204240">1 teaspoon ground cumin</p>
<p class="ul" id="d7e1204540">1 package (12 ounces) white or <br/> whole-wheat pitas</p>
<p class="pub" id="d7e1205340" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> Preheat oven to 425°F. In cup, with fork, mix oil, Parmesan, chili powder, and cumin.</p>
<p class="pub" id="d7e1206340"><span style="color: #c15b49"><b>2.</b></span> With knife or kitchen shears, carefully split each pita. Brush insides of pita halves lightly with oil mixture. Cut each half into 8 wedges.</p>
<p class="pub" id="d7e1207740"><span style="color: #c15b49"><b>3.</b></span> Transfer pita wedges to two ungreased cookie sheets (wedges can overlap slightly). Place cookie sheets on two oven racks and bake pita chips until edges are golden, 8 to 10 minutes. Watch carefully, as they can burn quickly.</p>
<p class="pub" id="d7e1209740"><span style="color: #c15b49"><b>4.</b></span> Transfer cookie sheets to wire racks and cool completely. Store chips in airtight container up to 1 week. Makes 8 dozen chips.</p>
<p class="ntx" id="d7e1211340">Each chip: About 20 calories, 0g protein, 2g carbohydrate, 1g total fat (0g saturated), 0mg cholesterol, 20mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c29_r1.vue?3cd2ba0e